import { Box, Flex } from '@chakra-ui/react'
import { FlexCol, FlexRow } from '@components'
import { useEmberStore } from '@features/Ember/infrastructure/useEmberStore'
import ChakraUIRenderer from 'chakra-ui-markdown-renderer'
import type { FC } from 'react'
import Markdown from 'react-markdown'
import { EmberAvatar } from './EmberAvatar'
import './styles/loading-states.css'
import { customChatTheme } from './styles/custom-chat-markdown-theme'

const ThinkingDots: FC = () => <Box m='4px' className='dot-flashing'></Box>

interface EmberMessageProps {
  text?: string | null
  isThinking?: boolean
  isThinkingExplanation?: boolean
}
export const EmberMessage: FC<EmberMessageProps> = ({ text, isThinking, isThinkingExplanation }) => {
  const isSidebarExpanded = useEmberStore(state => state.isSidebarExpanded)
  const formattedContent = (
    <>
      {text && (
        <Markdown components={ChakraUIRenderer(customChatTheme)} skipHtml>
          {text}
        </Markdown>
      )}
    </>
  )

  return (
    <FlexRow mr='auto' alignItems={'center'} gap={'6px'} maxW={isSidebarExpanded ? '90%' : '100%'}>
      <Flex mt='auto' mr={'-3px'} mb={'-3px'}>
        <EmberAvatar isThinking={isThinking} size='24px' />
      </Flex>

      <FlexCol borderRadius={'2px'} padding={'10px'} bg='#DCF1F6'>
        {isThinking ? (
          <Flex flexDirection={isThinkingExplanation ? 'row' : 'column'} alignItems={'center'} justifyContent={'center'} gap={'14px'}>
            <ThinkingDots />
            {formattedContent}
          </Flex>
        ) : (
          formattedContent
        )}
      </FlexCol>
    </FlexRow>
  )
}
